// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rq_a bib_a bib_r bib_sb bib_ry bib_rz","GroupsGrid__row__item":"rq_b bib_be bib_rz"};